"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentValidityDetailsCardCms = void 0;
var PaymentValidityDetailsCardCms = /** @class */ (function () {
    function PaymentValidityDetailsCardCms() {
        this.expirationDateLabel = 'Expiration date';
        this.expirationMonthLabel = 'Expiration Month';
        this.expirationYearLabel = 'Expiration Year';
        this.expirationDatePlaceHolder = 'mm/yy';
        this.numbersOnlyErrorText = 'Restrict to numbers only';
        this.expirationVaildityErrorMsg = 'Enter a valid Expiration date';
        this.expiryDateErrTxt = "Cannot be expired i.e. expiration month/year cannot be equal or prior to current month or year";
    }
    return PaymentValidityDetailsCardCms;
}());
exports.PaymentValidityDetailsCardCms = PaymentValidityDetailsCardCms;
//# sourceMappingURL=PaymentValidityDetailsCardCms.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/components/cards/PaymentCard/PaymentValidityDetailsCard/PaymentValidityDetailsCardCms.cms.js
// module id = 2028
// module chunks = 8